
<template>
  <div>
<!--    <vue-headful :title="getTitle" description="Allt um bílar | bilaskra.is"/>-->
    <NavigationLinks/>
    <slot></slot>

    <Footer v-if="isIosApp && isMain" />
  </div>
</template>

<script>
import NavigationLinks from '@/components/Blog/navigationLinks'
import Footer from "@/components/Footer";
import {mapGetters, mapState} from "vuex";

export default {
  metaInfo() {
    return {
      title: this.getTitle,
      titleTemplate: '%s | bilaskra.is',
      meta: this.getMeta,
      htmlAttrs: {
        lang: 'en',
        amp: true
      }
    }
  },
  props: {
    title: {
      type: String,
      default: 'Allt um bíla'
    }
  },
  computed: {
    ...mapState('blog', {
      post: state => state.simplePage
    }),
    pageTitle() {
      return this.post.title || 'Bilaskra.is - Leitarvél nýrra bíla frá öllum umboðum';
    },
    getCurImage() {
      const post = this.post;
      if (post && post.img) {
        return post.img;
      } else {
        return {
          img: '/img/share2.png?22',
          height: 800,
          width: 1200
        }
      }
    },
    getMeta() {
      const post = this.post;
      const image = this.getCurImage;

      let res = [
        {name: 'og:title', content: post.title || 'Bilaskra.is - Leitarvél nýrra bíla frá öllum umboðum' },
        {
          name: 'og:description',
          content: post.description || 'Finndu bíla á tilteknu verði, af tiltekinni stærð eða gerð og berðu saman kostina sem umboðin bjóða.'
        },
        {name: 'og:image', content: image.img},
        {name: 'og:image:height', content: image.height},
        {name: 'og:image:width', content: image.width},
      ];
      return res;
    },
    ...mapGetters(["isIosApp"]),
    isMain(){
      let inPost = ['Blog','Fréttir','Reynsluakstur'];
      return inPost.indexOf(this.$route.name) === -1;
      //return this.$route.name != 'Blog';
    },
    getTitle() {
      if(!this.title){
        return 'Bilaskra.is - Leitarvél nýrra bíla frá öllum umboðum';
      }
      return `${this.title} | bilaskra.is`
    }
  },
  components: {
    NavigationLinks,
    Footer
  }
}
</script>